import { loggedInUser } from "core/redux/slice/authSlice";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export default function useCompanyInfo() {
  const { companyDetails } = useSelector(loggedInUser);

  return companyDetails;
}
